import axios from 'axios';
import { useState, useEffect } from 'react';

const useRegearAdminLogic = () => {
  const [regearList, setRegearList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    async function refreshData() {
      console.log('Data Refreshed');
      await axios
        .get(process.env.REACT_APP_API_SERVER + '/regearAdmin')
        .then(function (res) {
          setRegearList(
            res.data.sort((a, b) => (a[1].date > b[1].date ? 1 : -1))
          );
          setIsLoading(false);
          if (regearList.length < 1) {
            setNoData(true);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
    refreshData();
    return () => {};
  }, [regearList.length]);

  async function deleteData(id) {
    await axios
      .delete(process.env.REACT_APP_API_SERVER + '/regearAdmin', {
        params: {
          docId: id,
        },
      })
      .then(function (res) {
        setRegearList(res.data);
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  function copyToClipboard(value) {
    setAlert(true);
    navigator.clipboard.writeText(value);
    setTimeout(resetAlertCopied, 2000);
  }

  function resetAlertCopied() {
    setAlert(false);
  }

  function formatSilverValue(value){
    const toString = value.toLocaleString()
    const removeDecimal = toString.split(".")[0]
    return removeDecimal
  }

  return {
    //functions
    deleteData,
    copyToClipboard,
    formatSilverValue,
    //setState
    //state
    alert,
    regearList,
    isLoading,
    noData,
  };
};

export default useRegearAdminLogic;
